<template>
  <div class="module-wrap">
    <div class="sub-title">基础信息</div>
    <div class="common-border">
      <el-row :gutter="20">
        <!-- 货场编码 -->
        <el-col :span="6">
          <el-form-item
            label="货场编码"
            prop="goodsYardInfoReq.goodsYardCode"
            required
          >
            <el-input v-model="formData.goodsYardCode" disabled />
          </el-form-item>
        </el-col>

        <!-- 分公司 -->
        <el-col :span="6">
          <el-form-item label="分公司" prop="goodsYardInfoReq.orgId" required>
            <el-select
              v-model="formData.orgId"
              placeholder="请选择"
              :disabled="partnershipType !== 3"
              clearable
              @change="handleOrgChange"
            >
              <el-option
                v-for="item in managementOptions"
                :key="item.partnershipId"
                :label="item.partnerName"
                :value="item.partnershipId.toString()"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 货场主信息 -->
        <el-col :span="6">
          <el-form-item
            label="货场主姓名"
            prop="goodsYardInfoReq.goodsYardUser"
            required
          >
            <el-input
              v-model="formData.goodsYardUser"
              maxlength="10"
              show-word-limit
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="货场联系电话"
            prop="goodsYardInfoReq.goodsYardPhone"
            required
          >
            <el-input v-model="formData.goodsYardPhone" maxlength="15" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 地址信息 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label="省"
            prop="goodsYardInfoReq.provinceCode"
            required
          >
            <el-select
              v-model="formData.provinceCode"
              placeholder="请选择省"
              @change="handleProvinceChange"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="市" prop="goodsYardInfoReq.cityCode" required>
            <el-select
              v-model="formData.cityCode"
              placeholder="请选择市"
              :disabled="!formData.provinceCode"
              @change="handleCityChange"
            >
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="区"
            prop="goodsYardInfoReq.districtCode"
            required
          >
            <el-select
              v-model="formData.districtCode"
              placeholder="请选择区"
              :disabled="!formData.cityCode"
              @change="handleDistrictChange"
            >
              <el-option
                v-for="item in districtList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="县" prop="goodsYardInfoReq.townCode" required>
            <el-select
              v-model="formData.townCode"
              placeholder="请选择县"
              :disabled="!formData.districtCode"
              @change="handleTownChange"
            >
              <el-option
                v-for="item in townList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 其他基础信息 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label="货场详细地址"
            prop="goodsYardInfoReq.address"
            required
          >
            <el-input
              v-model="formData.address"
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="货场面积"
            prop="goodsYardInfoReq.goodsYardSquare"
            required
          >
            <el-input
              v-model="formData.goodsYardSquare"
              maxlength="10"
              type="number"
              min="1"
            >
              <template slot="append">m²</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="月供货量"
            prop="goodsYardInfoReq.monthNum"
            required
          >
            <el-input
              v-model="formData.monthNum"
              maxlength="10"
              type="number"
              min="0"
            >
              <template slot="append">套</template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="年供货量"
            prop="goodsYardInfoReq.yearNum"
            required
          >
            <el-input
              v-model="formData.yearNum"
              maxlength="10"
              type="number"
              min="0"
            >
              <template slot="append">套</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 经营情况 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            label="经营情况"
            prop="goodsYardInfoReq.businessCategory"
            required
          >
            <el-select
              v-model="formData.businessCategory"
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="(val, key) in businessCategory"
                :key="key"
                :label="val"
                :value="key"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicInfoSection",

  props: {
    formData: {
      type: Object,
      required: true,
    },
    managementOptions: {
      type: Array,
      default: () => [],
    },
    partnershipType: {
      type: Number,
      default: null,
    },
    provinceList: {
      type: Array,
      default: () => [],
    },
    cityList: {
      type: Array,
      default: () => [],
    },
    districtList: {
      type: Array,
      default: () => [],
    },
    townList: {
      type: Array,
      default: () => [],
    },
    businessCategory: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    handleOrgChange(value) {
      this.$emit("update:org-name", value);
    },

    handleProvinceChange(value) {
      this.$emit("province-change", value);
    },

    handleCityChange(value) {
      this.$emit("city-change", value);
    },

    handleDistrictChange(value) {
      this.$emit("district-change", value);
    },

    handleTownChange(value) {
      this.$emit("town-change", value);
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/dataBoard/components/BasicInfoSection.vue